import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const CalendarConnectSuccess: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => navigate('/calendars'), 2000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="text-green-600 text-4xl mb-4">✓</div>
        <p className="text-gray-600 dark:text-gray-300 mb-4">Calendar connected successfully!</p>
        <p className="text-sm text-gray-500 dark:text-gray-400">Redirecting to calendars...</p>
      </div>
    </div>
  );
};
